import React, { useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

import { tokens } from "../../theme";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import SensorsIcon from "@mui/icons-material/Sensors";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";

import Footer from "./Footer";

const Item = ({ title, to, icon, selected, setSelected }) => {
  return (
    <MenuItem
      active={selected === title}
      onClick={() => setSelected(title)}
      icon={icon}
      style={{ color: "#ffffff" }}
    >
      <Link
        to={to}
        style={{
          textDecoration: "none",
          color: "inherit",
          display: "block",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Typography fontSize="0.88rem" noWrap>
          {title}
        </Typography>
      </Link>
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        alignSelf: "stretch",
        display: "flex",
        backgroundColor: "#11192A",
        overflowX: "hidden",
        flexShrink: 0,

        "& .pro-sidebar": {
          height: "100% !important",
          minHeight: "100vh !important",
          overflowX: "hidden !important",
        },

        "& .pro-sidebar-inner": {
          background: "#11192A !important",
          height: "100% !important",
          minHeight: "100vh !important",
          overflowX: "hidden !important",
        },

        "& .pro-sidebar-layout": {
          height: "100% !important",
          minHeight: "100vh !important",
          display: "flex !important",
          flexDirection: "column !important",
          overflowX: "hidden !important",
        },

        "& .pro-menu": {
          flexShrink: 0,
          overflowX: "hidden !important",
        },

        "& .pro-sidebar-footer": {
          marginTop: "auto !important",
        },

        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },

        "& .pro-inner-item": {
          padding: "4px 30px 4px 18px !important",
          minHeight: "37px !important",
        },

        "& .pro-item-content": {
          fontSize: "0.88rem !important",
          overflow: "hidden !important",
        },

        "& .pro-inner-item:hover": {
          color: "#8EBBFF !important",
        },

        "& .pro-menu-item.active": {
          color: "#8EBBFF !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "9px 0 16px 0",
              color: "#ffffff",
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="12px"
                sx={{ overflow: "hidden" }}
              >
                <a
                  href="https://nfdi4ing.de/"
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                  style={{ display: "inline-flex", alignItems: "center" }}
                >
                  <img
                    alt="NFDI4ING"
                    src={`../../assets/NFDI4ing_Logo_White_Sidebar_2.png`}
                    style={{
                      height: "34px",
                      width: "auto",
                      objectFit: "contain",
                      objectPosition: "left center",
                      cursor: "pointer",
                    }}
                  />
                </a>

                <IconButton
                  onClick={() => setIsCollapsed(!isCollapsed)}
                  size="small"
                >
                  <MenuOutlinedIcon sx={{ color: "#ffffff", fontSize: 19 }} />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {/* Phase Divider */}
          {!isCollapsed && (
            <Box
              mt="13px"
              mb="9px"
              px="16px"
              display="flex"
              alignItems="center"
              gap="8px"
              sx={{ opacity: 0.9 }}
            >
              <Box
                sx={{
                  height: "1px",
                  flex: 1,
                  backgroundColor: "rgba(255,255,255,0.18)",
                }}
              />

              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.55)",
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  fontWeight: 600,
                  fontSize: "0.7rem",
                  whiteSpace: "nowrap",
                }}
              >
                NFDI4ING 1st Phase
              </Typography>

              <Box
                sx={{
                  height: "1px",
                  flex: 1,
                  backgroundColor: "rgba(255,255,255,0.18)",
                }}
              />
            </Box>
          )}

          {/* GOLO */}
          {!isCollapsed && (
            <Box mb="20px">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ position: "relative", zIndex: 2 }}
              >
                <a
                  href="https://nfdi4ing.de/6-23-2/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ display: "inline-block" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <img
                    alt="GOLO"
                    width="84px"
                    height="84px"
                    src={`../../../../assets/Golo.jpg`}
                    style={{
                      cursor: "pointer",
                      borderRadius: "50%",
                      display: "block",
                    }}
                  />
                </a>
              </Box>

              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color="#ffffff"
                  fontWeight="bold"
                  sx={{ m: "7px 0 0 0" }}
                >
                  GOLO
                </Typography>

                <Typography fontSize="0.9rem" color={colors.greenAccent[500]}>
                  Field Data
                </Typography>
              </Box>
            </Box>
          )}

          {/* Phase Divider */}
          {!isCollapsed && (
            <Box
              mt="13px"
              mb="9px"
              px="16px"
              display="flex"
              alignItems="center"
              gap="8px"
              sx={{ opacity: 0.9 }}
            >
              <Box
                sx={{
                  height: "1px",
                  flex: 1,
                  backgroundColor: "rgba(255,255,255,0.18)",
                }}
              />

              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.55)",
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  fontWeight: 600,
                  fontSize: "0.7rem",
                  whiteSpace: "nowrap",
                }}
              >
                NFDI4ING 2nd Phase
              </Typography>

              <Box
                sx={{
                  height: "1px",
                  flex: 1,
                  backgroundColor: "rgba(255,255,255,0.18)",
                }}
              />
            </Box>
          )}

          {/* FIONA */}
          {!isCollapsed && (
            <Box mb="20px">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ position: "relative", zIndex: 2 }}
              >
                <a
                  href="https://nfdi4ing.de/home/25_services/25_manyparticipantsmanydevices/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ display: "inline-block" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <img
                    alt="FIONA"
                    width="84px"
                    height="84px"
                    src={`../../../../assets/Fiona.jpg`}
                    style={{
                      cursor: "pointer",
                      borderRadius: "50%",
                      display: "block",
                    }}
                  />
                </a>
              </Box>

              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color="#ffffff"
                  fontWeight="bold"
                  sx={{ m: "7px 0 0 0" }}
                >
                  FIONA
                </Typography>

                <Typography fontSize="0.9rem" color={colors.greenAccent[500]}>
                  Data Re-Use
                </Typography>
              </Box>
            </Box>
          )}

          {/* MENU ITEMS */}
          <Box
            paddingLeft={isCollapsed ? undefined : "8%"}
            sx={{ overflowX: "hidden" }}
          >
            <Item
              title="About the platform"
              to="/"
              icon={<InfoOutlinedIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Field Use-Cases"
              to="/homepage"
              icon={<DashboardOutlinedIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Typography
              fontSize="0.82rem"
              fontWeight={600}
              color={colors.grey[300]}
              sx={{
                m: "15px 0 5px 0",
                textAlign: isCollapsed ? "center" : "left",
                ml: isCollapsed ? 0 : "20px",
              }}
            >
              {isCollapsed ? "LUH" : "LUH - IPeG"}
            </Typography>

            <Item
              title="IPeG Dashboard"
              to="/luh/dashboard"
              icon={<HomeOutlinedIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Drives"
              to="/luh/drives"
              icon={<DirectionsCarFilledIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Recordings"
              to="/luh/recordings"
              icon={<RadioButtonCheckedIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="GPS"
              to="/luh/gps"
              icon={<GpsFixedIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="IMU"
              to="/luh/imu"
              icon={<DeviceHubIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Images"
              to="/luh/images"
              icon={<PhotoCameraIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="LiDAR"
              to="/luh/lidar"
              icon={<SensorsIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Timestamps"
              to="/luh/timestamps"
              icon={<AccessTimeFilledIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Dataset Explorer"
              to="/luh/calendardata"
              icon={<CalendarTodayOutlinedIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            {/* DFKI SECTION */}
            <Typography
              fontSize="0.82rem"
              fontWeight={600}
              color={colors.grey[300]}
              sx={{
                m: "15px 0 5px 0",
                textAlign: isCollapsed ? "center" : "left",
                ml: isCollapsed ? 0 : "20px",
              }}
            >
              {isCollapsed ? "DFKI" : "DFKI - RIC"}
            </Typography>

            <Item
              title="DFKI Dashboard"
              to="/dfki/robival/dashboard"
              icon={<HomeOutlinedIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Experiments"
              to="/dfki/robival/experiments"
              icon={<PrecisionManufacturingIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            {/* RWTH SECTION */}
            <Typography
              fontSize="0.82rem"
              fontWeight={600}
              color={colors.grey[300]}
              sx={{
                m: "15px 0 5px 0",
                textAlign: isCollapsed ? "center" : "left",
                ml: isCollapsed ? 0 : "20px",
              }}
            >
              {isCollapsed ? "RWTH" : "RWTH - WZL"}
            </Typography>

            <Item
              title="RWTH Dashboard"
              to="/rwth/drilloverview"
              icon={<HomeOutlinedIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="Drill Experiments"
              to="/rwth/drillexperiments"
              icon={<PrecisionManufacturingIcon fontSize="small" />}
              selected={selected}
              setSelected={setSelected}
            />
          </Box>
        </Menu>

        <Footer isCollapsed={isCollapsed} />
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
